import "../css/main.css";
import { toggleHamburger } from "./toggleHamburger";
import { accordion } from "./accordion";
import { tabMenu } from "./tabMenu";
import { initializeViewport } from "./initializeViewport";
import { initBackToTopButton } from "./backToTop";
import { smoothScrollToHash, setupAnchorLinks } from "./smoothScroll";
import { topServiceSlider } from "./topServiceSlider";
import { fixedHeader } from "./fixedHeader";
import { serviceChapterToggle } from "./serviceChapterToggle";
import { modalMap } from "./modalMap";
import { typingAnimation } from "./typingAnimation";
import { topIntroPop } from "./topIntroPop";

function getScrollOffset() {
  const headerHeight = Number(getComputedStyle(document.documentElement).getPropertyValue("--height-header")) || 0;
  return headerHeight + 20;
}

document.addEventListener("DOMContentLoaded", () => {
  toggleHamburger("js-hamburger", "js-spmenu", 1024);
  accordion();
  tabMenu();
  initializeViewport();
  initBackToTopButton();
  setupAnchorLinks(getScrollOffset());
  topServiceSlider();
  fixedHeader();
  serviceChapterToggle();
  modalMap();
  typingAnimation();
  topIntroPop();
});

window.addEventListener("load", () => {
  smoothScrollToHash(getScrollOffset());
});
